module.exports = __webpack_public_path__ + "img/PWstudio.b9f61951.jpg";